// @owners { team: patient-health }
import { SPACING } from '@alto/design-library-tokens';
// eslint-disable-next-line @alto/no-pocky-import
import { Column, Modal, ModalContent, Text } from '@alto/pocky';
import React from 'react';
import styled from 'styled-components';
import { IMG_ALT_TEXTS } from '~shared/constants';
import HeaderImage, { MODAL_SIZE } from '~web/components/HeaderImage';
import helpBubbleTransparent from '~web/images/helpBubbleTransparent@2x.png';

const StyledModal = styled(Modal)`
  .modal-header {
    border-bottom: none;
  }
`;

type Props = {
  readonly onClose: () => void;
};

export const PriorAuthModal = ({ onClose }: Props) => (
  <StyledModal
    dismissOnOutsideClick
    showDismiss
    onClose={onClose}
  >
    <ModalContent textAlignment="left">
      <Column spacing={SPACING.STATIC.MD.rem}>
        <HeaderImage
          src={helpBubbleTransparent}
          alt={IMG_ALT_TEXTS.helpBubble}
          title="Prior authorization"
          imgSize={MODAL_SIZE}
        />
        <Text>
          Your insurance requires your provider to explain the medical necessity of this medication before they will
          approve coverage.
        </Text>
        <Text>This process is called a prior authorization and usually takes 5 - 7 days.</Text>
        <Text>We'll notify you when your medication is ready to schedule for delivery.</Text>
      </Column>
    </ModalContent>
  </StyledModal>
);
